import React from 'react';
import { useEditMode } from '../../hooks/useEditMode';
import { StyledDivComponent, StyledInputComponent } from '../../dto/StyleCompRepository';
import HeadlessInput from '../headless/input/HeadlessInput';
import styled from 'styled-components';
import { TextAlignment } from '../../enum/EnumRepository';
import { useStandardAlertStore } from '../../store/portal/alertStore';

interface MoleculeInputDivProps {
  value: string | number;
  placeholder: string;
  defaultValue?: string | number;
  DefaultDiv?: StyledDivComponent;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  inputStyle: StyledInputComponent;
  StyledDiv: StyledDivComponent;
  alignment?: TextAlignment;
  minLimit?: number;
  maxLimit?: number;
  maxLength?: number;
}

const MoleculeInputDiv: React.FC<MoleculeInputDivProps> = ({
  value,
  placeholder,
  defaultValue,
  DefaultDiv,
  handleChange,
  inputStyle,
  StyledDiv,
  alignment,
  minLimit,
  maxLimit,
  maxLength
}) => {
  const { isEditMode } = useEditMode();
  const { setTextLengthExceededAlert } = useStandardAlertStore();

  const valueStr = value == null ? '' : String(value);

  const handleChangeWithLimit = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (maxLength && e.target.value.length > maxLength) {
      setTextLengthExceededAlert(maxLength);
      return;
    }
    handleChange(e);
  }

  return (
    <>
      {isEditMode ? (
        <HeadlessInputWrapper>
          {maxLength && (
            <LimitDiv>
              {valueStr.length} / {maxLength}
            </LimitDiv>
          )}
          <HeadlessInput
            type={'text'}
            value={valueStr}
            handleChange={maxLength ? handleChangeWithLimit : handleChange}
            placeholder={placeholder}
            StyledInput={inputStyle}
            $alignment={alignment || TextAlignment.CENTER}
            minLimit={minLimit}
            maxLimit={maxLimit}
          />
        </HeadlessInputWrapper>
      ) : (
        !!value ? (
          <StyledDiv $alignment={alignment || TextAlignment.CENTER}>{value}</StyledDiv>
        ) : (
          DefaultDiv && defaultValue ? (
            <DefaultDiv>{defaultValue}</DefaultDiv>
          ) : null
        )
      )}
    </>
  );
};

const HeadlessInputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const LimitDiv = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  color: ${({ theme }) => theme.colors.color_Gray_05};
  ${({ theme }) => theme.typography.Body_04};
  user-select: none;
  z-index: 1;
`;


export default MoleculeInputDiv;
